import Link from "next/link";
import React from "react";
import Image from "next/image";
import whiteLogo from "@/public/img/logo-side-white.svg";
import { enqueueSnackbar } from "notistack";
import ManageConsentButton from "@/utils/analytics-provider/manage-consent-button";
import { Transition } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/20/solid";
import Spinner from "@/components/common/spinner";

const Footer = () => {
  const year = new Date().getFullYear();

  const [email, setEmail] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const submitNewsletter = async () => {
    setSubmitting(true);
    const res = await fetch("/api/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    if (res.ok) {
      // enqueueSnackbar("Subscribed to newsletter", { variant: "success" });
      // try {
      //   const resBody = await res.json();
      //   enqueueSnackbar("Email ID: " + resBody.email, { variant: "info" });
      // } catch (e) {
      //   enqueueSnackbar("Error parsing response", { variant: "error" });
      // }
      setEmail("");
      setSubmitted(true);
    } else {
      enqueueSnackbar("Failed to subscribe to newsletter", {
        variant: "error",
      });
    }
    setSubmitting(false);
  };

  return (
    <footer className="mt-auto flex flex-col justify-between bg-footer-background p-4 text-sm text-white/80 high-contrast-theme:text-white">
      <div className="container flex flex-col gap-6 py-4 pb-8 text-white/80 high-contrast-theme:text-white sm:flex-row md:flex-col">
        <div className="flex flex-col gap-8 md:flex-row">
          <div className="flex flex-col gap-8 md:grow">
            <div className="relative flex h-12 w-32 items-start">
              <Image src={whiteLogo} alt="AlHayat Foodstuff" fill />
            </div>
            <div className="flex flex-col gap-2 sm:max-w-72">
              <div className="">Sign up to our Newletter</div>
              <form
                action=""
                className="relative flex w-full overflow-hidden rounded"
                onSubmit={(e) => {
                  e.preventDefault();
                  if (!submitting) submitNewsletter();
                }}
              >
                <input
                  type="email"
                  placeholder="Your Email"
                  accept="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="grow rounded-none bg-white p-2  text-black outline-none placeholder:text-black/60 hover:bg-white active:bg-white"
                ></input>
                <button
                  type="submit"
                  className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-none bg-secondary p-0 text-white transition-colors duration-100 hover:bg-secondary-600 active:bg-secondary-400"
                  // disabled={submitting}
                >
                  {!submitting ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="h-6 w-6"
                    >
                      <path d="M1.94607 9.31543C1.42353 9.14125 1.4194 8.86022 1.95682 8.68108L21.043 2.31901C21.5715 2.14285 21.8746 2.43866 21.7265 2.95694L16.2733 22.0432C16.1223 22.5716 15.8177 22.59 15.5944 22.0876L11.9999 14L17.9999 6.00005L9.99992 12L1.94607 9.31543Z"></path>
                    </svg>
                  ) : (
                    <Spinner className="h-6 w-6 fill-white/80 text-white/40" />
                  )}
                </button>
                <Transition
                  show={submitted}
                  className={`absolute inset-0 flex items-center justify-center overflow-hidden bg-success font-semibold text-black/80`}
                  enter="transition-all duration-300"
                  enterFrom="ltr:left-full rtl:right-full"
                  enterTo="ltr:left-0 rtl:right-0"
                >
                  <CheckIcon className="h-6 w-6" />
                  <div>Subscribed!</div>
                </Transition>
              </form>
            </div>
          </div>

          <div className="flex gap-8 sm:flex-col md:flex-row">
            <div className="flex w-1/2 flex-col gap-4 md:w-64 lg:w-96 ">
              <div className="text-lg font-medium">Company</div>
              <Link
                href="/"
                className="self-start text-white opacity-80 transition-opacity duration-100 hover:opacity-100"
              >
                Home
              </Link>
              <Link
                href="/products"
                className="self-start text-white opacity-80 transition-opacity duration-100 hover:opacity-100"
              >
                Products
              </Link>
              <Link
                href="/about"
                className="self-start text-white opacity-80 transition-opacity duration-100 hover:opacity-100"
              >
                About
              </Link>
              <Link
                href="/contact"
                className="self-start text-white opacity-80 transition-opacity duration-100 hover:opacity-100"
              >
                Contact
              </Link>
            </div>
            <div className="flex w-1/2 flex-col gap-2 md:w-64 lg:w-96">
              <div className="text-lg font-medium">Follow Us</div>
              <div className="flex gap-8">
                <Link
                  href="https://www.facebook.com/AlHayatFoodstuff"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-80 transition-opacity duration-100 hover:opacity-100"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="h-6 w-6"
                  >
                    <path
                      d="M17 2H14C12.6739 2 11.4021 2.52678 10.4645 3.46447C9.52678 4.40215 9 5.67392 9 7V10H6V14H9V22H13V14H16L17 10H13V7C13 6.73478 13.1054 6.48043 13.2929 6.29289C13.4804 6.10536 13.7348 6 14 6H17V2Z"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="fill-none stroke-white"
                    />
                  </svg>
                </Link>
                <Link
                  href="https://www.twitter.com/alhayatfoodstuff"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-80 transition-opacity duration-100 hover:opacity-100"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="h-6 w-6 p-0.5"
                  >
                    <path
                      d="M13.941 10.392L21.5355 1.5H19.7355L13.143 9.2205L7.87499 1.5H1.79999L9.76499 13.176L1.79999 22.5H3.59999L10.563 14.346L16.1265 22.5H22.2015L13.941 10.392ZM11.4765 13.278L10.6695 12.1155L4.24799 2.865H7.01249L12.1935 10.3305L13.0005 11.493L19.737 21.198H16.9725L11.4765 13.278Z"
                      className="fill-white"
                    />
                  </svg>
                </Link>
                <Link
                  href="https://www.linkedin.com/company/alhayatfoodstuff"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-80 transition-opacity duration-100 hover:opacity-100"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="h-6 w-6"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5 1.25C4.27065 1.25 3.57118 1.53973 3.05546 2.05546C2.53973 2.57118 2.25 3.27065 2.25 4C2.25 4.72935 2.53973 5.42882 3.05546 5.94454C3.57118 6.46027 4.27065 6.75 5 6.75C5.72935 6.75 6.42882 6.46027 6.94454 5.94454C7.46027 5.42882 7.75 4.72935 7.75 4C7.75 3.27065 7.46027 2.57118 6.94454 2.05546C6.42882 1.53973 5.72935 1.25 5 1.25ZM3.75 4C3.75 3.66848 3.8817 3.35054 4.11612 3.11612C4.35054 2.8817 4.66848 2.75 5 2.75C5.33152 2.75 5.64946 2.8817 5.88388 3.11612C6.1183 3.35054 6.25 3.66848 6.25 4C6.25 4.33152 6.1183 4.64946 5.88388 4.88388C5.64946 5.1183 5.33152 5.25 5 5.25C4.66848 5.25 4.35054 5.1183 4.11612 4.88388C3.8817 4.64946 3.75 4.33152 3.75 4ZM2.25 8C2.25 7.80109 2.32902 7.61032 2.46967 7.46967C2.61032 7.32902 2.80109 7.25 3 7.25H7C7.19891 7.25 7.38968 7.32902 7.53033 7.46967C7.67098 7.61032 7.75 7.80109 7.75 8V21C7.75 21.1989 7.67098 21.3897 7.53033 21.5303C7.38968 21.671 7.19891 21.75 7 21.75H3C2.80109 21.75 2.61032 21.671 2.46967 21.5303C2.32902 21.3897 2.25 21.1989 2.25 21V8ZM3.75 8.75V20.25H6.25V8.75H3.75ZM9.25 8C9.25 7.80109 9.32902 7.61032 9.46967 7.46967C9.61032 7.32902 9.80109 7.25 10 7.25H14C14.1989 7.25 14.3897 7.32902 14.5303 7.46967C14.671 7.61032 14.75 7.80109 14.75 8V8.434L15.185 8.247C15.935 7.92648 16.7307 7.7257 17.543 7.652C20.318 7.4 22.75 9.58 22.75 12.38V21C22.75 21.1989 22.671 21.3897 22.5303 21.5303C22.3897 21.671 22.1989 21.75 22 21.75H18C17.8011 21.75 17.6103 21.671 17.4697 21.5303C17.329 21.3897 17.25 21.1989 17.25 21V14C17.25 13.6685 17.1183 13.3505 16.8839 13.1161C16.6495 12.8817 16.3315 12.75 16 12.75C15.6685 12.75 15.3505 12.8817 15.1161 13.1161C14.8817 13.3505 14.75 13.6685 14.75 14V21C14.75 21.1989 14.671 21.3897 14.5303 21.5303C14.3897 21.671 14.1989 21.75 14 21.75H10C9.80109 21.75 9.61032 21.671 9.46967 21.5303C9.32902 21.3897 9.25 21.1989 9.25 21V8ZM10.75 8.75V20.25H13.25V14C13.25 13.2707 13.5397 12.5712 14.0555 12.0555C14.5712 11.5397 15.2707 11.25 16 11.25C16.7293 11.25 17.4288 11.5397 17.9445 12.0555C18.4603 12.5712 18.75 13.2707 18.75 14V20.25H21.25V12.38C21.25 10.476 19.589 8.972 17.68 9.146C17.0242 9.20567 16.3817 9.36763 15.776 9.626L14.296 10.261C14.1818 10.31 14.0573 10.3299 13.9336 10.3189C13.8098 10.3079 13.6907 10.2663 13.587 10.1979C13.4833 10.1295 13.3982 10.0364 13.3394 9.927C13.2806 9.81757 13.2499 9.69524 13.25 9.571V8.75H10.75Z"
                      className="fill-white"
                    />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <div className="text-lg font-medium">Offices</div>
          <div className="flex grow flex-col gap-8 md:flex-row">
            <div className="flex flex-col md:grow">
              <div className="pb-2 text-base font-medium">Poland</div>
              {/* <div className="">Al Hayat Foodstuff Sp. z o.o.</div> */}
              <div className="">
                Kamionna 22A
                <br />
                06-120 Winnica
              </div>
            </div>
            <div className="md: flex flex-col md:w-64 lg:w-96">
              <div className="pb-2 text-base font-medium">Egypt</div>
              {/* <div className="">Al Hayat Food Stuff Co. W.L.L.</div> */}
              <div className="">
                Building 63, Zone 8, Lotus District
                <br />
                5th Settlement, New Cairo
              </div>
            </div>
            <div className="md: flex flex-col md:w-64 lg:w-96">
              <div className="pb-2 text-base font-medium">Qatar</div>
              {/* <div className="">AlHayat Foodstuff Co. W.L.L.</div> */}
              <div className="">
                455 Salwa Road
                <br />
                Doha
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-auto flex flex-wrap justify-between border-t border-white/30 py-4 text-white/50 high-contrast-theme:text-white">
        <div className="">
          © {year} AlHayat Foodstuff. All rights reserved.
        </div>
        <div className="flex gap-2">
          <Link href="/privacy">Privacy Policy</Link>
          •
          <ManageConsentButton asLink />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
